import { Stack, Typography, Box, Container } from "@mui/material";
import { HeaderMinimal } from "src/components/Header";
import { Article, LegalNotice } from "src/components/LegalNotice";

import { PrivacyPolicyHeader } from "./components/PrivacyPolicyHeader";
import { PrivacyPolicySubheader } from "./components/PrivacyPolicySubheader";
import { PRIVACY_POLICY_ARTICLES } from "./config";

export const PrivacyPolicy = () => {
  return (
    <>
      <HeaderMinimal />

      <Container component="main">
        <Stack py={12}>
          <PrivacyPolicyHeader />

          <Typography
            variant="body2"
            textTransform="uppercase"
            textAlign="center"
            color="primary"
            sx={{ mt: 2.25 }}
          >
            By using padre gg services you agree to our terms and conditions.
          </Typography>

          <Box mt={5}>
            <PrivacyPolicySubheader />
          </Box>

          <Box mt={7}>
            <LegalNotice>
              {PRIVACY_POLICY_ARTICLES.map((article, articleIndex) => (
                <Article
                  key={article.title}
                  {...article}
                  articleNo={articleIndex + 1}
                />
              ))}
            </LegalNotice>
          </Box>
        </Stack>
      </Container>
    </>
  );
};
